const CHROME_VCARD_MIME = "text/vcard";
const SAFARI_VCARD_MIME = "text/vcard";

const ensureVcfExtension = (filename = "contact") => {
  const trimmed = String(filename).trim() || "contact";
  return trimmed.toLowerCase().endsWith(".vcf") ? trimmed : `${trimmed}.vcf`;
};

const normalizeVCardLineEndings = (text = "") =>
  String(text).replace(/\r\n/g, "\n").replace(/\n/g, "\r\n");

const isSafari = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const isAppleTouchMac =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  const isIos = /iP(ad|hone|od)/.test(ua) || isAppleTouchMac;
  const isMacSafari =
    /Macintosh/.test(ua) && /Safari/.test(ua) && !/Chrome|Chromium|Edg/.test(ua);
  const isOtherBrowserOnApple =
    /CriOS|FxiOS|EdgiOS|OPiOS|mercury|Chrome|Chromium|Edg|Firefox/.test(ua);

  if (isIos) return !isOtherBrowserOnApple;
  return isMacSafari;
};

const triggerAnchorDownload = (url, filename) => {
  const element = document.createElement("a");
  element.href = url;
  element.setAttribute("download", filename);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

/**
 * Downloads or opens a vCard.
 * - Safari: navigate to a text/vcard Blob URL so Add Contact can run.
 * - Chrome / others: Blob + <a download=".vcf"> so Chrome's vCard handler runs
 *   (Web Share only shows the "open with" sheet).
 */
export const downloadVCard = async (filename, text) => {
  const safeName = ensureVcfExtension(filename);
  const normalized = normalizeVCardLineEndings(text);
  const safari = isSafari();
  const mime = safari ? SAFARI_VCARD_MIME : CHROME_VCARD_MIME;
  const blob = new Blob([normalized], { type: mime });

  if (safari) {
    // Do not revoke: navigation needs the object URL to remain valid.
    window.location.href = URL.createObjectURL(blob);
    return;
  }

  const url = URL.createObjectURL(blob);
  triggerAnchorDownload(url, safeName);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
